var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('p',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.dataField.label)+" ")]),_c('div',{staticClass:"dashed__line"}),_c('p',{staticClass:"data",domProps:{"innerHTML":_vm._s(_vm.dataField.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }